import { Tooltip } from 'src/app/model/tooltip';
import { Question } from 'src/app/model/question';

export class HealthLifestyle {
    section: Sections[];
    questionSetName: string;
}

export class Sections {
    sectionName: string;
    sRecurrence: string;
    question: LifeStyleQuestion[];
}


export class LifeStyleQuestion {
    id: string;
    questionText: string;
    responseMethod: string;
    helpText: string;
    controlType: string;
    controlStyle: string;
    responseValue: string[];
    defaultResponseValue: string;
    mandatoryResponse: string;
    responseRange: string;
    label: string;
    nextStep: NextStep[];
    mandatoryInitialDisplay: string;
    mandatoryInitialDisplayInSection: string;
    dcjCustomerDisplay: string;
    responseFormat: string;
    responseType: string;
    origoElement: string;
    origoSection: string;
    origoAttribute: string;
    responseValueByUser: string;
    associatedResponseValueByUser: string;
    imagePath: string;
    specialInstructions: SpecialInstructions[];
    sectionNameToRefer: string;
    questionLabel: string;
}

export class DateDropdownQuestionsListModel {
    annuitant: LifeStyleQuestion[] = [];
    dependant: LifeStyleQuestion[] = [];
}

export class SpecialInstructions {

    specialInstructionType: string;
    specialInstructionValue: string;
}

export class NextStep {
    nextStepSelectedResponse: string;
    nextStepType: string;
    nextStepValue: string[];
}

export class depQuesRef {
    refQuesId: string;
    depQuesObj: LifeStyleQuestion;
}
export class rangeData {
    valueKey: string;
    recordType: string;
    valueMin: string;
    valueMax: string;
}
export class dayMonthYearRangeDataModel {
    valueMin: string;
    valueMax: string;
}

export class ErrorMsgModel {
    isValid: boolean;
    errorMessage: string;
    questionId: string;
}
export class conversionChangeModel {
    feetValue: number;
    inchValue: number;
    centimeterValue: string;
    stoneValue: number;
    poundsValue: number;
    kgsValue: number;
}
export class diabetesConversionChangeModel {
    iffcValue: string;
    dcctValue: string;

}
